export default function validateEmailAddress(value) {
    let isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    isValid = isValid && value.charAt(0) !== '<' && value.charAt(value.length - 1) !== '>' && value.charAt(value.length - 1) !== '.';

    return isValid;
}